import { formatISO, parseISO } from 'date-fns';
import TeamUser from './team-user';
export default class Team {
    constructor(dto) {
        this.dto = Object.assign({}, dto);
    }
    get id() {
        return this.dto.id;
    }
    set id(id) {
        this.dto.id = id;
    }
    get parentId() {
        var _a, _b;
        return (_b = (_a = this.dto.parent) === null || _a === void 0 ? void 0 : _a.substring('/teams/'.length)) !== null && _b !== void 0 ? _b : null;
    }
    set parentId(parentId) {
        this.dto.parent = parentId ? `/teams/${parentId}` : null;
    }
    get title() {
        return this.dto.title;
    }
    set title(title) {
        this.dto.title = title;
    }
    get description() {
        return this.dto.description;
    }
    set description(description) {
        this.dto.description = description;
    }
    get dateCreated() {
        return parseISO(this.dto.dateCreated);
    }
    set dateCreated(dateCreated) {
        this.dto.dateCreated = formatISO(dateCreated);
    }
    get dateUpdated() {
        return parseISO(this.dto.dateUpdated);
    }
    set dateUpdated(dateUpdated) {
        this.dto.dateUpdated = formatISO(dateUpdated);
    }
    get teamUsers() {
        return this.dto.teamUsers.map(teamUserDto => new TeamUser(teamUserDto));
    }
    set teamUsers(teamUsers) {
        this.dto.teamUsers = teamUsers.map(teamUser => teamUser.dto);
    }
    get memberCount() {
        return this.dto.memberCount;
    }
    set memberCount(memberCount) {
        this.dto.memberCount = memberCount;
    }
    get childCount() {
        return this.dto.childCount;
    }
    set childCount(childCount) {
        this.dto.childCount = childCount;
    }
    get readable() {
        return this.dto.readable;
    }
    get editable() {
        return this.dto.editable;
    }
    get deletable() {
        return this.dto.deletable;
    }
    get childHierarchy() {
        return this.dto.childHierarchy;
    }
    get params() {
        const teamMembers = [];
        for (const teamMember of this.teamUsers) {
            teamMembers.push({
                team: `/teams/${this.dto.id}`,
                user: `/users/${teamMember.userId}`,
                owner: teamMember.owner,
                admin: teamMember.admin,
            });
        }
        const data = {
            parent: this.dto.parent,
            title: this.title,
            description: this.description,
            teamUsers: teamMembers,
        };
        return data;
    }
}
//# sourceMappingURL=team.js.map